import { qweIsEmpty } from "../../common/commonHelper";
import dayjs from "../../utils/dayjs"

let BooleanField = {
    operatorOptions:[
        {
            "text":"等于",
            "value":"eq"
        },
        {
            "text":"不等于",
            "value":"neq"
        },
        {
            "text": "空值",
            "value": "isnull"
        },
        {
            "text": "不为空",
            "value": "isnotnull"
        }
    ],
    defaulOperator:"eq",

    buildFilter:function(data:any){
        data.value = data.value[0];
        return data;
    },

    createFilter:function(){
        return [false];
    }
}

let DateField = {
    operatorOptions:[
        {
            "text":"等于",
            "value":"eq"
        },
        {
            "text":"不等于",
            "value":"neq"
        },
        {
            "text": "早于",
            "value": "lt"
        },
        {
            "text": "早于等于",
            "value": "lte"
        },
        {
            "text": "晚于",
            "value": "gt"
        },
        {
            "text": "晚于等于",
            "value": "gte"
        },
        {
            "text": "范围选择",
            "value": "between"
        },
        {
            "text": "空值",
            "value": "isnull"
        },
        {
            "text": "不为空",
            "value": "isnotnull"
        },
    ],
    defaulOperator:"between",

    buildFilter:function(data:any){
        let today, tomorrow, fieldName;
        switch(data.operator){
            case "eq":
                data.operator = "between";
                today = dayjs(data.value[0]);
                tomorrow = today.add(1,"day");
                let value = [today.utc().format(),tomorrow.utc().format()];
                data.value = value;
                break;
            case "neq":
                today = dayjs(data.value[0]);
                tomorrow = today.add(1,"day");
                fieldName = data.field;
                data = {
                    logic:"and",
                    filters:[{
                        operator:"lt",
                        field:fieldName,
                        value:today.utc().format(),
                    },{
                        operator:"gt",
                        field:fieldName,
                        value:tomorrow.utc().format(),
                    }]
                }
                break;
            case "lt":
                today = dayjs(data.value[0]);
                data.value = today.utc().format();
                break;
            case "lte":
                today = dayjs(data.value[0]);
                tomorrow = today.add(1,"day");
                data.operator = "lt";
                data.value = tomorrow.utc().format();
                break;
            case "gt":
                today = dayjs(data.value[0]);
                tomorrow = today.add(1,"day");
                data.value = today.utc().format();
                break;
            case "gte":
                today = dayjs(data.value[0]);
                data.operator = "gte";
                data.value = today.utc().format();
                break;
            case "between":
                today = dayjs(data.value[1]);
                tomorrow = today.add(1,"day");
                data.value = [dayjs(data.value[0]).utc().format(),tomorrow.utc().format()];
                break;
            default:
                break;
        }
        return data;
    },

    createFilter:function(){
        let currentDate = new Date();
        let currentDay = new Date(
            currentDate.getFullYear(),
            currentDate.getMonth(),
            currentDate.getDate(),
            0,
            0,
            0
        );
        return [currentDay];
    }
}

let DepartField = {
    operatorOptions:[
        {
            "text": "包含任意一个",
            "value": "isin"
        },
        {
            "text": "不包含任意一个",
            "value": "unin"
        },
        {
            "text": "同时包含",
            "value": "allin"
        },
        {
            "text": "空值",
            "value": "isnull"
        }
    ],
    defaulOperator:"isin",

    buildFilter:function(data:any){
        let fileName = data.field;
        let value= data.value;
        let filters;
        switch (data.operator){
            case "isin":
                filters = value.map((x:any) => {return {
                    field:fileName,
                    operator:"contains",
                    value:x
                }});
                if(filters.length > 1){
                    data = {
                        logic:"or",
                        filters:filters
                    }
                }
                else{
                    data = filters[0];
                }
                break;
            case "unin":
                filters = value.map((x:any) => {return {
                    field:fileName,
                    operator:"doesnotcontain",
                    value:x
                }});
                if(filters.length > 1){
                    data = {
                        logic:"and",
                        filters:filters
                    }
                }
                else{
                    data = filters[0];
                }
                break;
            case "allin":
                filters = value.map((x:any) => {return {
                    field:fileName,
                    operator:"contains",
                    value:x
                }});
                if(filters.length > 1){
                    data = {
                        logic:"and",
                        filters:filters
                    }
                }
                else{
                    data = filters[0];
                }
                break;
            default:
                break;
        }
        return data;
    },

    createFilter:function(){
        return [];
    }
}

let MultChoiceProField = {
    operatorOptions:[
        {
            "text": "包含任意一个",
            "value": "isin"
        },
        {
            "text": "不包含任意一个",
            "value": "unin"
        },
        {
            "text": "同时包含",
            "value": "allin"
        },
        {
            "text": "空值",
            "value": "isnull"
        }
    ],
    defaulOperator:"isin",

    buildFilter:function(data:any){
        let fileName = data.field;
        let value= data.value;
        let filters;
        switch (data.operator){
            case "isin":
                filters = value.map((x:any) => {return {
                    field:fileName,
                    operator:"contains",
                    value:x
                }});
                if(filters.length > 1){
                    data = {
                        logic:"or",
                        filters:filters
                    }
                }
                else{
                    data = filters[0];
                }
                break;
            case "unin":
                filters = value.map((x:any) => {return {
                    field:fileName,
                    operator:"doesnotcontain",
                    value:x
                }});
                if(filters.length > 1){
                    data = {
                        logic:"and",
                        filters:filters
                    }
                }
                else{
                    data = filters[0];
                }
                break;
            case "allin":
                filters = value.map((x:any) => {return {
                    field:fileName,
                    operator:"contains",
                    value:x
                }});
                if(filters.length > 1){
                    data = {
                        logic:"and",
                        filters:filters
                    }
                }
                else{
                    data = filters[0];
                }
                break;
            default:
                break;
        }
        return data;
    },

    createFilter:function(){
        return [];
    }
}

let MultTextField = {
    operatorOptions:[
        {
            "text":"等于",
            "value":"eq"
        },
        {
            "text":"不等于",
            "value":"neq"
        },
        {
            "text": "空值",
            "value": "isnull"
        },
        {
            "text": "不为空",
            "value": "isnotnull"
        },
        {
            "text": "开头为",
            "value": "startswith"
        },
        {
            "text": "结尾为",
            "value": "endswith"
        },
        {
            "text": "包含",
            "value": "contains"
        },
        {
            "text": "不包含",
            "value": "doesnotcontain"
        }
    ],
    defaulOperator:"contains",

    buildFilter:function(data:any){
        data.value = data.value[0];
        return data;
    },

    createFilter:function(){
        return [];
    }
}

let NumericField = {
    operatorOptions:[
        {
            "text":"等于",
            "value":"eq"
        },
        {
            "text":"不等于",
            "value":"neq"
        },
        {
            "text": "小于",
            "value": "lt"
        },
        {
            "text": "小于等于",
            "value": "lte"
        },
        {
            "text": "大于",
            "value": "gt"
        },
        {
            "text": "大于等于",
            "value": "gte"
        },
        {
            "text": "范围选择",
            "value": "between"
        },
        {
            "text": "空值",
            "value": "isnull"
        },
        {
            "text": "不为空",
            "value": "isnotnull"
        }
    ],
    defaulOperator:"eq",

    buildFilter:function(data:any){
        if(FilterInputRule.includes(data.operator)){
            data.value = data.value[0];
        }
        return data;
    },

    createFilter:function(){
        return [];
    }
}

let PositionField = {
    operatorOptions:[
        {
            "text": "属于",
            "value": "contains"
        },
        {
            "text": "不属于",
            "value": "doesnotcontain"
        },
        {
            "text": "空值",
            "value": "isnull"
        },
        {
            "text": "不为空",
            "value": "isnotnull"
        }
    ],
    defaulOperator:"contains",

    buildFilter:function(data:any){
        let value = (data.value || []).join("");
        data.value = value;
        return data;
    },

    createFilter:function(){
        return [];
    }
}

let SingleChoiceProField = {
    operatorOptions:[
        {
            "text":"等于",
            "value":"eq"
        },
        {
            "text":"不等于",
            "value":"neq"
        },
        {
            "text": "等于任意一个",
            "value": "isin"
        },
        {
            "text": "不等于任意一个",
            "value": "unin"
        },
        {
            "text": "空值",
            "value": "isnull"
        }
    ],
    defaulOperator:"isin",

    buildFilter:function(data:any){
        if(FilterInputRule.includes(data.operator)){
            data.value = data.value[0];
        }
        return data;
    },
    
    createFilter:function(){
        return [];
    }
}

let SingleDepartField = {
    operatorOptions:[
        {
            "text":"等于",
            "value":"eq"
        },
        {
            "text":"不等于",
            "value":"neq"
        },
        {
            "text": "等于任意一个",
            "value": "isin"
        },
        {
            "text": "不等于任意一个",
            "value": "unin"
        },
        {
            "text": "空值",
            "value": "isnull"
        }
    ],
    defaulOperator:"eq",

    buildFilter:function(data:any){
        if(FilterInputRule.includes(data.operator)){
            data.value = data.value[0];
        }
        return data;
    },

    createFilter:function(){
        return [];
    }
}

let SingleUserField = {
    operatorOptions:[
        {
            "text":"等于",
            "value":"eq"
        },
        {
            "text":"不等于",
            "value":"neq"
        },
        {
            "text": "等于任意一个",
            "value": "isin"
        },
        {
            "text": "不等于任意一个",
            "value": "unin"
        },
        {
            "text": "空值",
            "value": "isnull"
        }
    ],
    defaulOperator:"eq",

    buildFilter:function(data:any){
        if(FilterInputRule.includes(data.operator)){
            data.value = data.value[0];
        }
        return data;
    },

    createFilter:function(){
        return [];
    }
}

let TextField = {
    operatorOptions:[
        {
            "text":"等于",
            "value":"eq"
        },
        {
            "text":"不等于",
            "value":"neq"
        },
        {
            "text": "空值",
            "value": "isnullorempty"
        },
        {
            "text": "不为空",
            "value": "isnotnullorempty"
        },
        {
            "text": "开头为",
            "value": "startswith"
        },
        {
            "text": "结尾为",
            "value": "endswith"
        },
        {
            "text": "包含",
            "value": "contains"
        },
        {
            "text": "不包含",
            "value": "doesnotcontain"
        },
        {
            "text": "等于任意一个",
            "value": "isin"
        },
        {
            "text": "不等于任意一个",
            "value": "unin"
        }
    ],
    defaulOperator:"contains",

    buildFilter:function(data:any){
        if(FilterInputRule.includes(data.operator)){
            data.value = data.value[0];
        }
        return data;
    },

    createFilter:function(){
        return [];
    }
}

let UserField = {
    operatorOptions:[
        {
            "text": "包含任意一个",
            "value": "isin"
        },
        {
            "text": "不包含任意一个",
            "value": "unin"
        },
        {
            "text": "同时包含",
            "value": "allin"
        },
        {
            "text": "空值",
            "value": "isnull"
        }
    ],
    defaulOperator:"isin",
    buildFilter:function(data:any){
        let fileName = data.field;
        let value= data.value;
        let filters;
        switch (data.operator){
            case "isin":
                filters = value.map((x:any) => {return {
                    field:fileName,
                    operator:"contains",
                    value:x
                }});
                if(filters.length > 1){
                    data = {
                        logic:"or",
                        filters:filters
                    }
                }
                else{
                    data = filters[0];
                }
                break;
            case "unin":
                filters = value.map((x:any) => {return {
                    field:fileName,
                    operator:"doesnotcontain",
                    value:x
                }});
                if(filters.length > 1){
                    data = {
                        logic:"and",
                        filters:filters
                    }
                }
                else{
                    data = filters[0];
                }
                break;
            case "allin":
                filters = value.map((x:any) => {return {
                    field:fileName,
                    operator:"contains",
                    value:x
                }});
                if(filters.length > 1){
                    data = {
                        logic:"and",
                        filters:filters
                    }
                }
                else{
                    data = filters[0];
                }
                break;
            default:
                break;
        }
        return data;
    },

    createFilter:function(){
        return [];
    }
}

let NoTypeField = {
    operatorOptions:[],
    defaulOperator:"",
    buildFilter:function(){
        return null;
    },
    createFilter:function(){
        return "";
    }
}

const FilterConfig = {
    "NoTypeField":NoTypeField,

    "BooleanField":BooleanField,
    "DateField":DateField,
    "DepartField":DepartField,
    "MultChoiceProField":MultChoiceProField,
    "MultTextField":MultTextField,
    "NumericField":NumericField,
    "PositionField":PositionField,
    "SingleChoiceProField":SingleChoiceProField,
    "SingleDepartField":SingleDepartField,
    "SingleUserField":SingleUserField,
    "TextField":TextField,
    "UserField":UserField,
    "PrimaryKeyField":TextField
}

const FilterInputRule = [
    "eq","neq","lt","lte",
    "gt","gte","startswith","doesnotstartwith",
    "endswith","doesnotendwith","contains","doesnotcontain"
]

const FilterMultSelectRule = ["isin","unin","allin"]

const FilterNullRule = ["isempty","isnotempty","isnullorempty","isnotnullorempty","isnull","isnotnull"]

const FilterBetweenRule = ["between"]

let checkFilter = function(filter:any){
    if(qweIsEmpty(filter.field) || qweIsEmpty(filter.operator)){
        return false;
    }
    else{
        if(FilterNullRule.includes(filter.operator)){
            return true;
        }
        else{
            return !qweIsEmpty(filter.value);
        }
    }
}

export {
    checkFilter,
    FilterConfig,
    FilterInputRule,
    FilterMultSelectRule,
    FilterNullRule,
    FilterBetweenRule
}
